module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-detail-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    首页 > " + _vm._s(_vm.goods.catName) + " > " + _vm._s(_vm.curGoodInfo.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "buy-detail"
  }, [_c('gallery', {
    attrs: {
      "gallery": _vm.gallery
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "g-name"
  }, [_vm._v("\n        " + _vm._s(_vm.curGoodInfo.name) + "\n        "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.goods_transfee_charge === 1),
      expression: "goods.goods_transfee_charge === 1"
    }]
  }, [_vm._v("包邮")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "meta"
  }, [_c('dl', [_c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.mktprice),
      expression: "curGoodInfo.mktprice"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag != '4' && _vm.goods.sourceFlag != '3'),
      expression: "goods.sourceFlag != '4' && goods.sourceFlag != '3'"
    }]
  }, [_vm._v("价　　格：")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag == '3'),
      expression: "goods.sourceFlag == '3'"
    }]
  }, [_vm._v("市场价：")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag == '4'),
      expression: "goods.sourceFlag == '4'"
    }]
  }, [_vm._v("会员价：")])]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.mktprice),
      expression: "curGoodInfo.mktprice"
    }]
  }, [_c('strong', {
    staticClass: "linear"
  }, [_vm._v("¥ " + _vm._s(_vm.curGoodInfo.mktprice)), _c('i', {
    staticClass: "linear"
  })])]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.price),
      expression: "curGoodInfo.price"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.goods.sourceFlag != '2' &&
        _vm.goods.sourceFlag != '3' &&
        _vm.goods.sourceFlag != '4'
      ),
      expression: "\n                  goods.sourceFlag != '2' &&\n                  goods.sourceFlag != '3' &&\n                  goods.sourceFlag != '4'\n                "
    }]
  }, [_vm._v("会员价：")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag == '2'),
      expression: "goods.sourceFlag == '2'"
    }]
  }, [_vm._v("特　　价：")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag == '3'),
      expression: "goods.sourceFlag == '3'"
    }]
  }, [_vm._v("批发价：")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.sourceFlag == '4'),
      expression: "goods.sourceFlag == '4'"
    }]
  }, [_vm._v("店长采购价：")])]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.price),
      expression: "curGoodInfo.price"
    }]
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.curGoodInfo.price))])]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.batchPrice > 0),
      expression: "curGoodInfo.batchPrice > 0"
    }]
  }, [_vm._v("批发价：")]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.batchPrice > 0),
      expression: "curGoodInfo.batchPrice > 0"
    }]
  }, [_c('strong', {
    attrs: {
      "nctype": "goods_price"
    }
  }, [_vm._v("¥ " + _vm._s(_vm.curGoodInfo.batchPrice))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "padding": "2px 6px",
      "-moz-border-radius": "5px",
      "-webkit-border-radius": "5px",
      "border-radius": "5px",
      "background-color": "#fe9d01",
      "color": "#fff"
    }
  }, [_c('router-link', {
    staticStyle: {
      "font-size": "12px",
      "color": "#fff"
    },
    attrs: {
      "to": {
        path: '/goods',
        query: {
          goods_id: _vm.curGoodInfo.oriGood
        },
      },
      "target": "_blank",
      "title": "查看原商品"
    }
  }, [_vm._v("查看原商品")])], 1)]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.curGoodInfo.couponAmount > 0 || _vm.goods.couponAmountByChain > 0
      ),
      expression: "\n                curGoodInfo.couponAmount > 0 || goods.couponAmountByChain > 0\n              "
    }]
  }, [_vm._v("\n              现金券抵扣：\n            ")]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.couponAmount > 0 && _vm.goods.sourceFlag != '2'),
      expression: "curGoodInfo.couponAmount > 0 && goods.sourceFlag != '2'"
    }]
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.curGoodInfo.couponAmount))])]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.selfShoppingPv),
      expression: "curGoodInfo.selfShoppingPv"
    }]
  }, [_vm._v("自营积分抵扣：")]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.selfShoppingPv),
      expression: "curGoodInfo.selfShoppingPv"
    }]
  }, [_c('strong', [_vm._v("¥ " + _vm._s(_vm.curGoodInfo.selfShoppingPv))])]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.subsidyPoint > 0 && _vm.goods.sourceFlag != '4'),
      expression: "goods.subsidyPoint > 0 && goods.sourceFlag != '4'"
    }]
  }, [_vm._v("\n              补助积分：\n            ")]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goods.subsidyPoint > 0 && _vm.goods.sourceFlag != '4'),
      expression: "goods.subsidyPoint > 0 && goods.sourceFlag != '4'"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.goods.subsidyPoint))])]), _vm._v(" "), _c('dt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.batchPrice === 0 && _vm.goods.sourceFlag != '4'),
      expression: "curGoodInfo.batchPrice === 0 && goods.sourceFlag != '4'"
    }]
  }, [_vm._v("\n              产品积分：\n            ")]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curGoodInfo.batchPrice === 0 && _vm.goods.sourceFlag != '4'),
      expression: "curGoodInfo.batchPrice === 0 && goods.sourceFlag != '4'"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.curGoodInfo.pv))])])]), _vm._v(" "), (!_vm.goods.isSelf || _vm.goods.buyNum > 0) ? _c('ul', [_c('li', [_c('p', {
    staticClass: "color1"
  }, [_vm._v(_vm._s(_vm.goods.buyNum))]), _vm._v(" "), _c('p', [_vm._v("累计售出")])]), _vm._v(" "), _c('li', {
    staticClass: "line3"
  }, [_c('p', {
    staticClass: "color2"
  }, [_vm._v(_vm._s(_vm.goods.memberCommentCount))]), _vm._v(" "), _c('p', [_vm._v("条评论")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "color3"
  }, [_vm._v(_vm._s(_vm.goods.goodsTypeDisplay))]), _vm._v(" "), _c('p', [_vm._v("商品类型")])])]) : _vm._e()]), _vm._v(" "), (_vm.currChoose.detail.length !== 0) ? _c('div', {
    staticClass: "choose"
  }, _vm._l((this.goodsSkuList.pOrderlist), function(fItem, fIndex) {
    return _c('div', {
      key: fIndex,
      staticClass: "li"
    }, [_c('div', {
      staticClass: "dt"
    }, [_vm._v(_vm._s(fItem) + "：")]), _vm._v(" "), _vm._l((_vm.choose[fItem]), function(cItem, cIndex) {
      return _c('div', {
        key: cIndex,
        staticClass: "item",
        class: {
          selected: cIndex === _vm.currChoose.detail[fIndex].index,
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.cChoose(fIndex, cItem, cIndex)
          }
        }
      }, [_c('a', {
        attrs: {
          "title": fItem
        }
      }, [_vm._v(_vm._s(cItem))])])
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_c('dl', [_c('dt', [_vm._v("购买数量：")]), _vm._v(" "), _c('dd', {
    staticClass: "figure-input"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.buyNumOpn('-')
      }
    }
  }, [_c('i', [_vm._v("-")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buyNum),
      expression: "buyNum"
    }],
    attrs: {
      "type": "text",
      "size": "3",
      "maxlength": "8",
      "oninput": "value = value ? value.replace(/[^\\d]/g,'') : ''"
    },
    domProps: {
      "value": (_vm.buyNum)
    },
    on: {
      "keyup": _vm.changeNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.buyNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.buyNumOpn('+')
      }
    }
  }, [_c('i', [_vm._v("+")])]), _vm._v(" "), (!_vm.goods.isSelf) ? _c('em', [_vm._v("(当前库存"), _c('strong', [_vm._v(_vm._s(_vm.curGoodInfo.idsStore))]), _vm._v("件)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (!_vm.goods.isSelf && _vm.curGoodInfo.idsStore == 0) ? _c('div', {
    staticClass: "btn clearfix"
  }, [_c('p', [_vm._v("抱歉，暂无库存")])]) : _c('div', {
    staticClass: "btn clearfix"
  }, [(_vm.isHaveType) ? _c('a', {
    staticClass: "buynow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cBuynow.apply(null, arguments)
      }
    }
  }, [_vm._v("立即购买")]) : _vm._e(), _vm._v(" "), (_vm.isHaveType) ? _c('a', {
    staticClass: "addcart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cAddCart.apply(null, arguments)
      }
    }
  }, [_vm._v("添加到购物车\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isHaveType) ? _c('a', {
    staticClass: "nobuynow"
  }, [_vm._v("立即购买")]) : _vm._e(), _vm._v(" "), (!_vm.isHaveType) ? _c('a', {
    staticClass: "noaddcart"
  }, [_vm._v("添加到购物车\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "share"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cShare.apply(null, arguments)
      }
    }
  }, [_c('span'), _vm._v(" "), (!_vm.isFavorite) ? _c('span', [_vm._v("收藏商品")]) : _vm._e(), _vm._v(" "), (_vm.isFavorite) ? _c('span', [_vm._v("取消收藏")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "store"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("店铺信息")]), _vm._v(" "), _c('div', {
    staticClass: "s-name",
    attrs: {
      "title": _vm.storeInfo.storeName
    }
  }, [_c('span', [_vm._v("商       铺：")]), _vm._v(_vm._s(_vm.storeInfo.storeName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "rating"
  }, [_c('span', [_vm._v("综合评分：")]), _c('span'), _vm._v(_vm._s(_vm.credit) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "credit-name"
  }, [_vm._v("店铺动态评分（满分5分）")]), _vm._v(" "), _c('div', {
    staticClass: "credit"
  }, [_vm._v("描述相符：" + _vm._s(_vm.storeInfo.storeDesccredit))]), _vm._v(" "), _c('div', {
    staticClass: "credit"
  }, [_vm._v("服务态度：" + _vm._s(_vm.storeInfo.storeServicecredit))]), _vm._v(" "), _c('div', {
    staticClass: "credit delivery"
  }, [_vm._v("\n          发货速度：" + _vm._s(_vm.storeInfo.storeDeliverycredit) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cStore.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("进入商家店铺")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('card', {
    attrs: {
      "storeId": _vm.goods.storeId,
      "catList": _vm.catList
    }
  }), _vm._v(" "), _c('detail', {
    attrs: {
      "goodsId": _vm.goods.goods_id,
      "storeId": _vm.goods.storeId,
      "goodsIntros": _vm.goods.intros,
      "goodsVideo": _vm.goods.goodsVideo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-957bf9ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/good-detail.vue
// module id = 1653
// module chunks = 1